const STATUS_LABEL = {
  active: 'Ativo',
  inative: 'Inativo',
  deleted: 'Excluído',
}

const STATUS_CLASS_NAME = {
  active: 'activeStatus',
  inative: 'inativeStatus',
  deleted: 'deletedStatus',
}

const certificates = {
  STATUS_LABEL,
  STATUS_CLASS_NAME,
}

export default certificates
